import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, IDR } from "@/lib/api";
import { toast } from "sonner";

const ORDER_STATUSES = ["NEW","PAYMENT_PENDING","PAID","PROCESSING","PRODUCTION","READY_TO_SHIP","SHIPPED","COMPLETED","CANCELLED","REFUNDED"];
const PROD_STATUSES = ["PENDING","SENT_TO_PRODUCTION","IN_PRODUCTION","COMPLETED"];
const SHIP_STATUSES = ["NOT_SHIPPED","READY","SHIPPED","DELIVERED"];

export default function AdminOrders() {
  const [orders, setOrders] = useState([]);
  const [sel, setSel] = useState(null);
  const load = () => api.get("/admin/orders").then((r) => setOrders(r.data));
  useEffect(() => { load(); }, []);
  const upd = async (field, value) => {
    const { data } = await api.patch(`/admin/orders/${sel.id}`, { [field]: value });
    setSel(data); load(); toast.success("Diperbarui");
  };
  return (
    <div>
      <h1 className="display text-4xl md:text-6xl mb-6">ORDERS</h1>
      <div className="grid md:grid-cols-[1fr,420px] gap-6">
        <div className="border border-[color:var(--border)] overflow-x-auto">
          <table className="w-full text-sm min-w-[700px]">
            <thead className="text-[10px] tracking-widest text-neutral-500"><tr className="border-b border-[color:var(--border)]">
              <th className="p-3 text-left">ORDER</th><th className="p-3 text-left">CUSTOMER</th><th className="p-3 text-left">TOTAL</th>
              <th className="p-3 text-left">PAY</th><th className="p-3 text-left">ORDER</th>
            </tr></thead>
            <tbody>{orders.map((o) => (
              <tr key={o.id} data-testid={`order-row-${o.order_number}`} className={`border-b border-[color:var(--border)] ${sel?.id === o.id ? "bg-[color:var(--surface)]" : ""}`}>
                <td className="p-3 mono"><Link to={`/admin/orders/${o.id}`} data-testid={`order-link-${o.order_number}`} className="underline">{o.order_number}</Link></td>
                <td className="p-3 cursor-pointer" onClick={() => setSel(o)}>{o.customer.name}</td>
                <td className="p-3 tabular-nums cursor-pointer" onClick={() => setSel(o)}>{IDR(o.total)}</td>
                <td className="p-3 cursor-pointer" onClick={() => setSel(o)}><span className="status-badge">{o.payment_status}</span></td>
                <td className="p-3 cursor-pointer" onClick={() => setSel(o)}><span className="status-badge">{o.order_status}</span></td>
              </tr>))}</tbody>
          </table>
        </div>
        {sel && (
          <aside className="border border-[color:var(--border)] p-4 space-y-3 text-sm">
            <div className="display text-2xl">{sel.order_number}</div>
            <div className="text-[10px] tracking-widest text-neutral-500">CUSTOMER</div>
            <div>{sel.customer.name}<br/>{sel.customer.email}<br/>{sel.customer.phone}</div>
            <div className="text-[10px] tracking-widest text-neutral-500 mt-3">ITEMS</div>
            <div className="space-y-1">{sel.items.map((it, i) => <div key={i} className="text-xs">{it.article_code} · {it.name} · {it.color}/{it.size} × {it.qty}</div>)}</div>
            <div className="mt-3 space-y-2">
              <label className="text-[10px] tracking-widest text-neutral-500">ORDER STATUS
                <select data-testid="upd-order-status" className="mt-1 w-full bg-transparent border border-[color:var(--border)] p-2" value={sel.order_status} onChange={(e) => upd("order_status", e.target.value)}>
                  {ORDER_STATUSES.map((s) => <option key={s}>{s}</option>)}
                </select></label>
              <label className="text-[10px] tracking-widest text-neutral-500">PRODUCTION
                <select data-testid="upd-prod-status" className="mt-1 w-full bg-transparent border border-[color:var(--border)] p-2" value={sel.production_status} onChange={(e) => upd("production_status", e.target.value)}>
                  {PROD_STATUSES.map((s) => <option key={s}>{s}</option>)}
                </select></label>
              <label className="text-[10px] tracking-widest text-neutral-500">SHIPPING
                <select data-testid="upd-ship-status" className="mt-1 w-full bg-transparent border border-[color:var(--border)] p-2" value={sel.shipping_status} onChange={(e) => upd("shipping_status", e.target.value)}>
                  {SHIP_STATUSES.map((s) => <option key={s}>{s}</option>)}
                </select></label>
            </div>
          </aside>
        )}
      </div>
    </div>
  );
}
